import { render, staticRenderFns } from "./UniversalBlockComponent.vue?vue&type=template&id=7a9ae97b"
import script from "./UniversalBlockComponent.vue?vue&type=script&lang=js"
export * from "./UniversalBlockComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports